import React, {Component} from "react";
import {css} from "aphrodite/no-important";
import {styles} from "./AccountStyles";
import {connect} from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import Spacer from "../components/Spacer";
import AccountSubheader from "../components/AccountSubheader";
import {Field, reduxForm} from "redux-form";
import {accountHomeViewActions,} from "../_actions";
import {withCookies} from "react-cookie";
import AccountBackButton from "../components/AccountBackButton";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";

// const validate = (values, allValues) => {
//   const errors = {};

//   if (values.standing_charge) {
//   }

//   return errors;
// };

const renderField = (props) => {
  const {
    input,
    label,
    type,
    meta: { touched, error, warning },
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError,
  ]);
  return (
    <div>
      <label className={css(styles.label)}>{label}</label>
      <div>
        <input
          {...input}
          placeholder={label}
          type={type}
          className={inputStyles}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
};
class AccountHomeViewTariffStandingCharge extends Component {
  constructor(props) {
    super(props);
    const user = JSON.parse(localStorage.getItem("user"));
    const level = props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    this.state = {
      submitted: false,
      failed: false,
    };

    this.props.dispatch(accountHomeViewActions.getTariff(user));
  }
  submit = (values) => {
      const user = JSON.parse(localStorage.getItem("user"));
      const level = this.props.match.params.level;
      if (level == "infocare") {
        user.user_id = user.dependant_user_id;
      }

      const dataObj = {
        standing_charge: {
          days: "all",
          prices: [Number(values.standing_charge)],
          times: [0],
          rate_names: ["fix"],
        },
      };

      return this.props.dispatch(accountHomeViewActions.setTariff(user.user_id, dataObj));
  };
  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      submitSucceeded,
      submitFailed,
    } = this.props;

    if (submitSucceeded && this.props.accountHomeView.detail.status) {
      this.setState({
        failed: true,
        submitted: false,
      });
    }

    if (submitSucceeded && !this.state.submitted && !this.state.failed) {
      this.setState({
        submitted: true,
        failed: false,
      });
    }

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backLabel="Tariff"
            backHref={`/account/${this.props.match.params.level}/tariff/`}
            title="Standing Charge"
          />
          {!this.state.failed && (
            <form onSubmit={handleSubmit(this.submit)}>
              <Spacer />
              <Field
                name="standing_charge"
                component={renderField}
                type={"number"}
                label="Standing Charge (£ per day)"
              />
              <button
                type="submit"
                disabled={submitting}
                className={css(styles.buttonGreen)}
              >
                Save Standing Charge
              </button>
            </form>
          )}

          {submitSucceeded && (
            <SuccessMessage message="Standing charge saved" />
          )}

          {submitFailed && (
            <ErrorMessage
              message={[
                "Standing charge could not be saved. Please ",
                <a
                  key="error0"
                  href="#0"
                  onClick={() => {
                    this.props.history.go(0);
                  }}
                  className={css(styles.link)}
                >
                  try again
                </a>,
              ]}
            />
          )}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let defaultStandingCharge;
  if (state.accountHomeView.detail.standing_charge) {
    defaultStandingCharge =
      state.accountHomeView.detail.standing_charge.prices[0].toFixed(2);
  } else if (
    state.accountHomeView.detail.used_tariff &&
    state.accountHomeView.detail.used_tariff.standing_charge
  ) {
    defaultStandingCharge =
      state.accountHomeView.detail.used_tariff.standing_charge.prices[0].toFixed(
        2
      );
  }
  // if (state && state.accountHomeView.detail.standing_charge !== null) {
  //   defaultStandingCharge =
  //     state.accountHomeView.detail.standing_charge.prices[0].toFixed(2);
  // } else {
  //   defaultStandingCharge =
  //     state.accountHomeView.detail.used_tariff.standing_charge.prices[0].toFixed(
  //       2
  //     );
  // }

  const initialValues = {
    standing_charge: defaultStandingCharge,
  };
  return {
    initialValues,
    ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewTariffStandingCharge",
    destroyOnUnmount: false,
    enableReinitialize: true,
    // validate,
  })(withCookies(AccountHomeViewTariffStandingCharge))
);
